export default {
  watch: {
    packageName(val, newVal) {
      if (val !== newVal) {
        this.getInfo();
      }
    },
  },
};
